/**
 * 主机品牌建设数量
 * zxw
 * 2024-08-09
 */

import React, { useEffect, useState } from 'react';
import Column from '@ant-design/plots/es/components/column';
import $ from 'jquery';
import { UjoinParams, AddRequestHeaders, winWidth } from '../../incs/FunHelper.js';
import CNF from '../../incs/Config.js';

const IDHMC = (props) => {
    const [data, setData] = useState([]);

    const getData = () => {
        const params = {
            'mod': 'IDHMC',
        }
        $.ajax({
            url: `${CNF.api}report/intersections${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            crossDomain: true,
            type: 'GET',
            dataType: 'JSON',success:function(data){
                if(data.res === 0){
                    if(data.dat.length>0){
                        setData(data.dat);
                    }
                }
            }
        })
    }

    useEffect(()=>{
        getData();
    },[]);

    const config = {
        data: data,
        width: (winWidth - 40) / 4,
        // padding: [0,0,0,0],
        paddingTop: 20,
        paddingRight: 10,
        xField: 'type',
        yField: 'count',
        tooltip: {
            items: [{ field: 'count',name: '数量', valueFormatter: (count) => `${count}` + '个', }],
        },
        title : {
            title: '主机品牌分类',
            size: 12,
            style: {
                titleFontSize: 12,
                titleFill: '#fff',
                align: 'center',
            },
        },
        axis:{
            x: {
              line: true,
              lineLineWidth: 1,
              lineStroke: props.lineColor,
              tickStroke: props.lineColor,
              labelFill: '#fff',
              labelFontSize: 12,
              labelStroke: '#fff',
              labelFillOpacity: 1,
              tickStrokeOpacity: 1,
            },
            y: {
                line: true,
                lineLineWidth: 1,
                lineStroke: props.lineColor,
                tickStroke: props.lineColor,
                labelFill: '#fff',
                labelStroke: '#fff',
                gridStroke: props.lineColor,
                labelFontSize: 12,
                labelFillOpacity: 1,
                tickStrokeOpacity: 1,
                gridStrokeOpacity: 1,
                gridLineWidth: 1,
                gridLineDash: [0,0]
            }
        },
        style: {
            fill: ({ type }) => {
                switch(type){
                    case CNF.brands[0]:
                        return '#3189FF';
                    case CNF.brands[1]:
                        return '#65C9CB';
                    case CNF.brands[2]:
                        return '#E59361';
                    case CNF.brands[3]:
                        return '#CD8BF9';
                    case CNF.brands[4]:
                        return '#7C6CF8';
                    case CNF.brands[5]:
                        return '#81C653';
                    default:
                        return '#BA9748';
                }
            },
            minWidth: 20,
            maxWidth: 30,
        },
        animate: { 
            enter: { 
                type: 'growInY',
                duration: 3000,
            }
        }
    };
    return <Column width={'100%'} {...config} />
}

export default IDHMC;